import * as _ from "lodash";
import * as queryString from "query-string";
import { useCallback, useEffect } from "react";

const PRECISION = 2;

function AddressBar({ view, setState }) {
  // const { view, setState } = useContext(State);

  const putViewInUrl = view => {
    const { latitude, longitude, zoom } = view;
    const map = {
      latitude: latitude.toFixed(PRECISION),
      longitude: longitude.toFixed(PRECISION),
      zoom: zoom.toFixed(1)
    };
    window.history.pushState(null, "", `?${queryString.stringify(map)}`);
  };

  const setStateFromUrl = () => {
    const { latitude, longitude, zoom } = queryString.parse(
      window.location.search
    );
    latitude &&
      longitude &&
      zoom &&
      setState({
        view: {
          latitude: Number(latitude),
          longitude: Number(longitude),
          zoom: Number(zoom)
        }
      });
  };

  const debounceCallback = useCallback(_.debounce(putViewInUrl, 200), []);
  useEffect(() => debounceCallback(view), [view]);
  useEffect(() => setStateFromUrl(), []);

  return null;
}
export default AddressBar;
